export enum GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD {
    supplierName = 'supplierName',
    gslNumber = 'gslNumber',
    isNewSupplier = 'isNewSupplier',
    date = 'date',
    shipToAddress = 'shipToAddress',
    shipToCity = 'shipToCity',
    shipToState = 'shipToState',
    shipToZip = 'shipToZip',
    country = 'country',
    requestorComments = 'requestorComments',
    supplierSerializationGuideCheck = 'supplierSerializationGuideCheck',
    buyerName = 'buyerName',
    shipToContactName = 'shipToContactName',
    phoneNumber = 'phoneNumber',
    emailAddress = 'emailAddress',
    file = 'file',
    business = 'business',
    tagStyle = 'tagStyle',
    requestId = 'requestId'
}

export interface fileObject {
    fileName: string;
    fileSize: number;
    fileId: string;
    fileExt: string;
    fileUrl: string;
    externalBannerUrl: string | null;
    isFilemanager: number;
}

export class GeTagRequest {
    supplierName: string;
    gslNumber: number;
    isNewSupplier: string;
    date: Date;
    shipToAddress: string;
    shipToCity: string;
    shipToState: string;
    shipToZip: string;
    country: string;
    requestorComments: string;
    supplierSerializationGuideCheck: string;
    buyerName: string;
    shipToContactName: string;
    phoneNumber: number;
    emailAddress: string;
    file: fileObject;
    business: string;
    tagStyle: string;
    requestId: string;

    constructor(params: any = {}, parsed: boolean = true) {
        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.supplierName = params.supplierName;
            this.gslNumber = params.gslNumber;
            this.isNewSupplier = params.isNewSupplier;
            this.date = params.date;
            this.shipToAddress = params.shipToAddress;
            this.shipToCity = params.shipToCity;
            this.shipToState = params.shipToState;
            this.shipToZip = params.shipToZip;
            this.country = params.country;
            this.requestorComments = params.requestorComments;
            this.supplierSerializationGuideCheck = params.supplierSerializationGuideCheck;
            this.buyerName = params.buyerName;
            this.shipToContactName = params.shipToContactName;
            this.phoneNumber = params.phoneNumber;
            this.emailAddress = params.emailAddress;
            this.file = params.file;
            this.business = params.business;
            this.tagStyle = params.tagStyle;
            this.requestId = params.requestId;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.supplierName = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.supplierName];
        this.gslNumber = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.gslNumber];
        this.isNewSupplier = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.isNewSupplier];
        this.date = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.date];
        this.shipToAddress = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToAddress];
        this.shipToCity = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToCity];
        this.shipToState = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToState];
        this.shipToZip = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToZip];
        this.country = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.country];
        this.requestorComments = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.requestorComments];
        this.supplierSerializationGuideCheck = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.supplierSerializationGuideCheck];
        this.buyerName = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.buyerName];
        this.shipToContactName = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToContactName];
        this.phoneNumber = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.phoneNumber];
        this.emailAddress = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.emailAddress];
        this.file = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.file];
        this.business = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.business];
        this.tagStyle = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.tagStyle];
        this.requestId = respObject[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.requestId];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.supplierName] = this.supplierName;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.gslNumber] = this.gslNumber;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.isNewSupplier] = this.isNewSupplier;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.date] = this.date;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToAddress] = this.shipToAddress;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToCity] = this.shipToCity;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToState] = this.shipToState;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToZip] = this.shipToZip;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.country] = this.country;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.requestorComments] = this.requestorComments;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.supplierSerializationGuideCheck] = this.supplierSerializationGuideCheck;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.buyerName] = this.buyerName;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.shipToContactName] = this.shipToContactName;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.phoneNumber] = this.phoneNumber;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.emailAddress] = this.emailAddress;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.file] = this.file;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.business] = this.business;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.tagStyle] = this.tagStyle;
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.requestId] = this.requestId;
        return body;
    }
}
